import { IMasonryTile } from "./IMasonryTile";
import { ProductTile } from "./ProductList";

export interface SearchRequest {
  term: string | null;
  categories: Array<string> | null;
  selectedFacets: Record<string, Array<string | number | boolean>> | null;
  pageNo: number;
  sorting: Sorting;
  requestFullResult: boolean;
  showOnlyAgreementProducts: boolean;
  contentId: string;
}

export interface SearchResponse {
  totalPages: number;
  tiles: Array<ProductTile>;
  facets: Array<FacetGroup>;
  facetNames: Record<string, string>;
  remainingProducts: number;
  totalHits: number;
}

export interface SearchCasesResponse {
  totalPages: number;
  casePages: Array<IMasonryTile>;
  facets: Array<FacetGroup>;
  facetNames: Record<string, string>;
  remainingProducts: number;
  totalHits: number;
}

export interface FacetGroup {
  key: string;
  available: Array<Facet>;
}

export interface Facet {
  value: string | boolean | number;
  hits: number;
  selected: boolean;
}

export enum Sorting {
  RelevanceDesc = "RelevanceDesc",
  RelevanceAsc = "RelevanceAsc",
  PopularityDesc = "PopularityDesc",
  PopularityAsc = "PopularityAsc",
  ListPriceDesc = "ListPriceDesc",
  ListPriceAsc = "ListPriceAsc",
}
